import { useMenu } from '@react-aria/menu';
import React__default, { useEffect } from 'react';
import { MenuItemInternal } from './menu-item-internal.js';
import { MenuSectionInternal } from './menu-section-internal.js';
import { useSwanMenuListContext } from './menu-list.context.js';
import { useCollectionContext } from '../../contexts/internal/collection/collection.context.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { useSwanPopover } from '../popover/popover.context.js';
import { assignRefs } from '../../../core/utilities/ref.utils.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * @subcomponent Menu
 */ const MenuList = renderWithRef('MenuList', null, (props, ref)=>{
    const { children, className, 'aria-label': ariaLabel } = props;
    const { setChildItems } = useCollectionContext();
    const { overlayState } = useSwanPopover();
    const { menuProps: menuListProps, menuState, menuRef } = useSwanMenuListContext();
    useEffect(()=>{
        setChildItems(()=>children);
    }, [
        setChildItems,
        children
    ]);
    const { menuProps } = useMenu(_object_spread_props(_object_spread({}, menuListProps), {
        'aria-label': ariaLabel
    }), menuState, menuRef);
    const combinedRef = assignRefs(ref, menuRef);
    const classes = new Set([
        'swan-menu-list',
        'swan-listbox-list'
    ]);
    if (className) classes.add(className);
    return /*#__PURE__*/ React__default.createElement("ul", _object_spread_props(_object_spread({}, props, menuProps), {
        ref: combinedRef,
        className: [
            ...classes
        ].join(' ')
    }), overlayState.isOpen ? [
        ...menuState.collection
    ].map((item)=>{
        return item.type === 'section' ? /*#__PURE__*/ React__default.createElement(MenuSectionInternal, {
            key: item.key,
            section: item,
            state: menuState
        }) : /*#__PURE__*/ React__default.createElement(MenuItemInternal, {
            key: item.key,
            item: item,
            state: menuState
        });
    }) : null);
});

export { MenuList };
